"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var AppointmentDetails_1 = require("./AppointmentDetails");
var AppointmentDetailsWrapper = function (_a) {
    var appointmentDetails = _a.appointmentDetails;
    var _b, _c, _d;
    if (!appointmentDetails) {
        return null;
    }
    return (<AppointmentDetails_1.default date={(_b = appointmentDetails) === null || _b === void 0 ? void 0 : _b.date} period={(_c = appointmentDetails) === null || _c === void 0 ? void 0 : _c.period} comments={(_d = appointmentDetails) === null || _d === void 0 ? void 0 : _d.comments}/>);
};
exports.default = AppointmentDetailsWrapper;
